import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { enWebPage } from "../lib/ConstCommand";
import { setCurrentPageType } from "../lib/RabbitmqClient";
import { exitPageFullscreen } from "../hooks/usePageFullscreen";
import { create_class_monitor_session, get_class_monitor_access, get_class_monitor_lives } from "../lib/api/user";
import "../styles/class-monitor.css";

// 260728 SmartTV 로그인처럼 별도 계정 로그인 없이 진행 중 클래스를 선택하는 전용 화면이다.
const WebClassMonitorLoginPage = ({ routeProps }) => {
    const { t } = useTranslation("live");
    const [listLive, setListLive] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [message, setMessage] = useState("");
    // 20260813 접속 불가 안내와 정상 클래스 선택 안내가 동시에 표시되지 않도록 상태를 분리한다.
    const [isAccessAllowed, setIsAccessAllowed] = useState(false);
    // 20260824 진행 중 클래스는 있지만 선생님이 클래스 모니터를 허용하지 않은 경우를 구분한다.
    const [disabledClassMonitorLiveCount, setDisabledClassMonitorLiveCount] = useState(0);

    useEffect(() => {
        exitPageFullscreen(); // 260803 클래스 모니터 로그인 화면에서는 전체화면을 자동 해제한다.
        let isMounted = true;
        setCurrentPageType(enWebPage.ClassMonitorLogin); // 260728 새로고침·오류 이동도 공통 page type 분기를 사용한다.
        setIsLoading(true);
        // 20260812 서버 허가 확인이 성공한 경우에만 기존 클래스 목록 조회를 수행한다.
        get_class_monitor_access()
        .then(() => {
            if (isMounted) setIsAccessAllowed(true);
            return get_class_monitor_lives();
        })
        .then(response => {
            if (isMounted) {
                setListLive(response.data.list_live || []);
                setDisabledClassMonitorLiveCount(response.data.disabledClassMonitorLiveCount || 0);
            }
        })
        .catch(error => {
            const reasonCode = error.response && error.response.data && error.response.data.reasonCode;
            // 20260812 서버의 사유 코드를 화면 언어에 맞는 안내 문구로 변환한다.
            if (isMounted) setMessage(reasonCode ? t(`클래스_모니터_오류_${reasonCode}`) : t("클래스_모니터_목록_조회_실패"));
        })
        .finally(() => {
            if (isMounted) setIsLoading(false);
        });
        // 260728 화면 이동 뒤 비동기 응답이 상태를 변경하지 않도록 한다.
        return () => { isMounted = false; };
    }, [t]);

    const enterClass = liveSeq => {
        setIsLoading(true);
        setMessage("");
        create_class_monitor_session(liveSeq) // 260728 별도 HiClassTV 로그인 없이 선택한 클래스 세션을 생성한다.
        .then(response => {
            sessionStorage.setItem("classMonitorSession", JSON.stringify(response.data));
            // 260728 클래스 선택 화면을 거친 동일 세션의 라우팅만 모니터 화면 진입을 허용한다.
            routeProps.history.push(`/class-monitor/${liveSeq}`, {
                fromClassMonitorLogin: true,
                monitorSessionId: response.data.monitorSessionId
            });
        })
        .catch(error => {
            const reasonCode = error.response && error.response.data && error.response.data.reasonCode;
            setMessage(reasonCode ? t(`클래스_모니터_오류_${reasonCode}`) : t("클래스_모니터_세션_생성_실패"));
            setIsLoading(false); // 260728 실패해 화면이 유지될 때만 로딩 상태를 해제한다.
        });
    };

    return (
        <main className="class-monitor-login">
            <section>
                <h1>Class Monitor</h1>
                {isLoading && <p>{t("클래스_모니터_불러오는_중")}</p>}
                {/* 20260904 번역 문구에 포함된 <br/> 등 태그가 그대로 노출되지 않고 동작하도록 HTML로 렌더링한다. */}
                {!isLoading && !isAccessAllowed && message && <p className="class-monitor-error" dangerouslySetInnerHTML={{ __html: message }} />}
                {!isLoading && isAccessAllowed && <>
                    <p>{t("클래스_모니터_클래스_선택_안내")}</p>
                    {message && <p className="class-monitor-error" dangerouslySetInnerHTML={{ __html: message }} />}
                    <div className="class-monitor-class-list">
                        {listLive.map(info => (
                            <button type="button" key={info.LIVE_SEQ} onClick={() => enterClass(info.LIVE_SEQ)} disabled={isLoading}>
                                <strong>{info.LIVE_NAME}</strong>
                                <span>{info.LIVE_TEACHER_NICKNAME || info.USER_NICKNAME}</span>
                            </button>
                        ))}
                    </div>
                    {!message && listLive.length === 0 && <p>{disabledClassMonitorLiveCount > 0 ? t("클래스_모니터_진행_클래스_미허용") : t("클래스_모니터_진행_클래스_없음")}</p>}
                </>}
            </section>
        </main>
    );
};

export default WebClassMonitorLoginPage;
